<!-- loading error -->
@if (error) {
  <div class="error" aria-label="error-message">{{ error }}</div>
} @else {
  <ng-container [ngTemplateOutlet]="template"></ng-container>
}
